import type { GpuHostOperationsView } from "dutyon-server/types";
import { useAuthStore } from "../auth/authStore";
import { httpClient } from "./httpClient";
import { proSupportRequestConfig } from "./pro-support-session";

/** Bind operator reads to the initiating session; never replay them after account changes. */
export async function getGpuHostOperations(
  owner: string,
  signal?: AbortSignal,
): Promise<GpuHostOperationsView> {
  const initiating = useAuthStore.getState();
  if (initiating.user?.role !== "SUPER_ADMIN") throw new Error("최고 관리자만 조회할 수 있습니다.");
  const config = proSupportRequestConfig(initiating, owner);
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener("abort", abort, { once: true });
  if (signal?.aborted) controller.abort();
  let changed = false;
  const unsubscribe = useAuthStore.subscribe((state) => {
    if (
      state.user?.sub !== owner ||
      state.user.role !== "SUPER_ADMIN" ||
      state.token !== initiating.token
    ) {
      changed = true;
      controller.abort();
    }
  });
  try {
    const response = await httpClient.get<GpuHostOperationsView>("/admin/gpu-host", {
      ...config,
      signal: controller.signal,
      timeout: 5000,
    });
    if (changed || controller.signal.aborted) throw new Error("계정이 변경되었습니다.");
    return response.data;
  } finally {
    unsubscribe();
    signal?.removeEventListener("abort", abort);
  }
}
